import { createContext } from 'react';
import type { RuleOverrides } from '../data/ruleRegistry';

export interface RulesContextValue {
  /** Merged overrides (for passing to domain functions) */
  overrides: RuleOverrides;
  /** Whether overrides are still loading */
  loading: boolean;
  /** Reload overrides from DB */
  refresh: () => void;
  /** Convenience: get a resolved rule value */
  getValue: <T = unknown>(ruleId: string) => T;
}

export const RulesContext = createContext<RulesContextValue | null>(null);
